<template>
  <ul class="ushk-rili_list-wrap">
    <li class="ushk-rili_list-empty" v-if="!datas || !datas.length">
      <img src="//cdn.jin10.com/assets/img/sites/rili/empty_holiday.png">
      <p>{{ !datas ? '加载中......' : '今日无假期休市安排' }}</p>
    </li>
    <li v-for="(data, index) in datas" class="ushk-rili_list-item">
        <div class="ushk-rili_list-country">
            <img :src="`//www.ushknews.com/img/company/large/${data.country}.png`">
        </div>
        <div class="ushk-rili_list-body">
            <div class="ushk-rili_list-h">
                <div class="ushk-rili_list-time">
                    <span>{{ data.holidayname }}</span>
                </div>
            </div>
            <h3 class="ushk-rili_list-title">{{ data.note }}</h3>
        </div>
    </li>
  </ul>
</template>
<script>
    export default {
      props: {
        datas: {
          type: [Array, Boolean],
          default: false
        }
      },
      data () {
        return {
        }
      }
    }
  </script>


// WEBPACK FOOTER //
// HolidayList.vue?4a272167